import {DESTINATION_FIELDS, FORM_ARRAY_BENEVA_ACCOUNTS, FORM_ARRAY_BENEVA_GUARANTEED_FUNDS} from '@/constants/engine';
import {ValueResolver} from '@/engine/types';
import {recursiveReplaceIndex} from '@/engine/utils/object';

type BenevaArrayType = typeof FORM_ARRAY_BENEVA_ACCOUNTS | typeof FORM_ARRAY_BENEVA_GUARANTEED_FUNDS;

export interface BenevaAccount {
  index: number;
  accountId: string;
  accountCode: string;
  accountFees: string;
  depositType: string;
  amountPeriodic: string;
  amountCash: string;
  amountEFT: string;
  amountTransfer: string;
}

/**
 * Generic function to retrieve Beneva accounts from a specific array type
 * @param valueResolver - The value resolver function
 * @param arrayType - The array type (FORM_ARRAY_BENEVA_ACCOUNTS or FORM_ARRAY_BENEVA_GUARANTEED_FUNDS)
 * @returns Array of Beneva accounts with their details
 */
export const getBenevaAccounts = (valueResolver: ValueResolver, arrayType: BenevaArrayType): BenevaAccount[] => {
  const fieldIds = DESTINATION_FIELDS[arrayType];

  const benevaAccountsCount = Number(valueResolver({$ref: `_${arrayType}[count]`}));
  const benevaAccounts: BenevaAccount[] = [];

  for (let index = 0; index < benevaAccountsCount; index++) {
    const accountId = valueResolver({$ref: recursiveReplaceIndex(fieldIds.id, index)}, {keepDomainReference: true});
    const accountCode = valueResolver({$ref: recursiveReplaceIndex(fieldIds.code, index)});
    const accountFees = valueResolver({$ref: recursiveReplaceIndex(fieldIds.fees, index)}, {keepDomainReference: true});
    const depositType = valueResolver({$ref: recursiveReplaceIndex(fieldIds.depositType, index)});
    const amountPeriodic = valueResolver({$ref: recursiveReplaceIndex(fieldIds.input.periodic, index)});
    const amountCash = valueResolver({$ref: recursiveReplaceIndex(fieldIds.input.cash, index)});
    const amountEFT = valueResolver({$ref: recursiveReplaceIndex(fieldIds.input.eft, index)});
    const amountTransfer = valueResolver({$ref: recursiveReplaceIndex(fieldIds.input.transfer, index)});

    benevaAccounts.push({
      index,
      accountId,
      accountCode,
      accountFees,
      depositType,
      amountPeriodic,
      amountCash,
      amountEFT,
      amountTransfer,
    });
  }
  return benevaAccounts;
};
